import AbstractFilterDefinition from './AbstractFilterDefinition.js'
import { dateIntervalObject, periods, incomingPeriods } from '../../../../helpers';

export default class DateIntervalDefinition extends AbstractFilterDefinition
{
    constructor(name, label, incoming = true, dateTime = true) {
        super(name, label);
        this.incoming = incoming;
        this.dateTime = dateTime;
    }

    get component() {
        return 'date-filter';
    }

    dataAdapter(data) {
        switch (data.mode) {
            case 'smartdate':
                return this.smartDateAdapter(data.smartdate);
            case 'between':
                
                if (this.dateTime) {
                    return {
                        start: data.start ? moment(data.start).toISOString() : '',
                        end: data.end ? moment(data.end).toISOString() : '',
                    };
                } else {
                    //date only
                    const format = "YYYY-MM-DD";
                    return {
                        start: data.start ? moment(data.start).format(format) : '',
                        end: data.end ? moment(data.end).format(format) : '',
                    }
                }
        }
        return null;
    }

    smartDateAdapter(smartdate) {
        const interval = dateIntervalObject(smartdate);
        if (interval.start === null || interval.end === null) {
            return null;
        }
        
        if (this.dateTime) {
            return {
                start: interval.start.toISOString(),
                end: interval.end.toISOString(),
            };
        } else {

            const format = "YYYY-MM-DD";

            return {
                start: interval.start.format(format),
                end: interval.end.format(format),
            } 
        }
    }

    get configuration() {

        const allowOptions = ['currentmonth', 'last30days', 'lastmonth', 'lastweek', 'yesterday'];
        let allPeriods;
        if (this.incoming) {
            allPeriods = [ ...periods, ...incomingPeriods ];
            allowOptions.push('today');
            allowOptions.push('tomorrow');
            allowOptions.push('nextweek');
            allowOptions.push('nextmonth');
            allowOptions.push('next30day');
        } else {
            allPeriods = [ ...periods ];
        }

        const options = {};
        allPeriods.filter(function (item) {
            return allowOptions.indexOf(item.value) !== -1;
        }).forEach(function (item) {
            options[item.value] = item;
        });

        const configuration =  {
            "mode": {
                "type": "radio",
                "name": "mode",
                "options": {
                    "smartdate": {
                        "value": "smartdate",
                        "label": i18n.__("Période définie")
                    },
                    "between": {
                        "value": "between",
                        "label": i18n.__("Période personnalisée")
                    },
                }
            },
            "smartdate": {
                "type": "select",
                "name": "smartdate",
                "placeholder": i18n.__('Aucun filtre défini'),
                "options": options
            },
            "start": {
                "type": "date",
                "name": "start"
            },
            "end": {
                "type": "date",
                "name": "end"
            }
        };



        return configuration;
    }
}